module.exports = __webpack_public_path__ + "img/premium.e30b451a.svg";